module.exports = __webpack_public_path__ + "img/youngcompass2.0dd732f9.png";